export enum Navigation {
  ASSIGNATIONS = "Assignations",
  POSITIONS = "Positions",
  WORKLOG_SUMMARY = "Worklog Summary",
  WORKLOG_REPORT = "Worklog Report",
}
